import { user } from "./UserProvider.slice";

export const userActions = { ...user.actions };
